import { createContext, useContext, useState, useEffect } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("rhc_lang") || "fr");
  useEffect(() => {
    localStorage.setItem("rhc_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const toggle = () => setLang((l) => (l === "fr" ? "en" : "fr"));
  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext) || { lang: "fr", setLang: () => {}, toggle: () => {} };
export const useT = () => {
  const { lang } = useLang();
  return translations[lang] || translations.fr;
};
